// origine de l'élément de dictionnaire
export enum DIC_ORIGIN {
  AI = 'AI',
  MANUAL = 'MANUAL',
}

// statuts du cv
export enum CV_STATE {
  DRAFT = 'DRAFT',
  VALID = 'VALID',
  OPEN = 'OPEN',
  ASSIGN = 'ASSIGN',
  REJECT = 'REJECT',
  CLOSED = 'CLOSED'
}

// constantes d'events
export enum APP_EVENT_TYPE {
  BREAD = 'BREAD', // affichage du bread
  SWAP_PANEL = 'SWAP_PANEL', // redimensionnement du panel de gauche
  DIC_ADD = 'DIC_ADD',
  DIC_DELETE = 'DIC_DELETE',
  DIC_EDIT = 'DIC_EDIT',
  MAIN_SAVE = 'MAIN_SAVE',
  MAIN_CANCEL = 'MAIN_CANCEL',
  MASS_ADD_CV = 'MASS_ADD_CV',
  MASS_ADD_JOB = 'MASS_ADD_JOB',

}